<template>
    <div>
        <table class="table table-borderless table-striped table-hover">
            <thead>
                <tr>
                    <th>{{translate('incomingDoc.remProvider')}}</th>
                    <th>{{translate('remPassword.remAddress')}}</th>
                    <th>{{translate('incomingDoc.username')}}</th>
                    <th>{{translate('remPasswordList.lastPasscodeDate')}}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="r in remAccounts" :key="r.Id">
                    <td>{{r.Provider}}</td>
                    <td>{{r.RemAddress}}</td>
                    <td>{{r.Username}}</td>
                    <td>
                        <span v-if="r.LastPasswordSetDate">{{ r.LastPasswordSetDate | datetime }}</span>
                        <i v-else class="text-muted">{{translate('remPasswordList.passcodeNotEntered')}}</i>
                    </td>
                    <td style="padding:0; vertical-align:middle">
                        <button type="button" class="btn btn-sm btn-secondary" @click="selectedId = r.Id">{{translate('remPasswordList.enterPasscode')}}</button>
                    </td>
                    <td style="padding:0; vertical-align:middle">
                        <button type="button" class="btn btn-sm btn-secondary" @click="openHsmModal(r)">{{translate('hsmIdentify.identifyHsm')}}</button>
                    </td>
                </tr>
            </tbody>
        </table>

        <rem-password v-if="selectedId" :id="selectedId" @close="selectedId = null" @save="onPasswordSave"></rem-password>
        <hsm-identify v-if="identifyHSM" :hsmAccountId="hsmAccountId" @close="identifyHSM = false"></hsm-identify>
    </div>
</template>
<script>
import axios from 'axios'
import remPassword from '../components/RemPassword.vue'
import HsmIdentify from './HsmIdentify.vue';

export default {
    components: {
        remPassword,
        HsmIdentify
    },
    created(){
        this.refreshData();
    },
    data(){
        return {
            selectedId: null,
            remAccounts: null,
            identifyHSM: false,
            hsmAccountId: null,
        }
    },
    methods: {
        openHsmModal(r){
            this.hsmAccountId = r.Id
            this.identifyHSM = true
        },
        onPasswordSave(){
            this.refreshData();
        },
        refreshData(){
            axios.post('/RemPassword/get')
            .then(x => {
                this.remAccounts = x.data.Result;
            })
            .catch(() => {
                this.remAccounts = [];
            })
        }
    }
}
</script>